<div class="main">
  <div class="section">
    <div class="header">
      {{'FEATURE_SUB_FEATURE.featuresTitle' | translate}}
      <i class="material-icons" (click)="closeDialog();">clear</i>
    </div>
    <div class="rolesSection">

      <div class="container">
        <mat-checkbox (click)="selectAll()">Select All</mat-checkbox>
          <li class="featuresList" *ngFor="let item of features; let i = index">
            <div>
              <img [hidden]='!item.subFeatures' (click)='item.showHide=!item.showHide;' class="dropdown-icon" src="assets/icon-dropdown.svg" alt=""> <!-- [hidden]='!item.subFeatures.length'-->
              <mat-checkbox [(ngModel)]="item.checked" (change)='featureSelect(item);'>{{item.name}}</mat-checkbox>
              <li class="subFeaturesList" [hidden]='!item.showHide' *ngFor="let sub of item.subFeatures; let ind = index">
                <mat-checkbox [(ngModel)]='sub.checked' (change)='subfeatureSelect(item);' >{{sub.name}}</mat-checkbox>
              </li>
            </div>
          </li>
      </div>
    </div>
    <div class="bottom">
      <div class="submitButton" (click)="submit()">
        <div class="button">
          {{'FEATURE_SUB_FEATURE.submitButton' | translate}}
        </div>
      </div>
    </div>
  </div>
</div>
